"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeButton = exports.InfoValue = exports.InfoTitle = exports.InfoWrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.InfoWrap = (0, app_1.styled)(ui_1.Grid) `
  grid-row-gap: 0.5rem;
  * {
    font-size: 0.875rem;
  }
`;
exports.InfoTitle = app_1.styled.span `
  color: black;
  line-height: 150%;
  letter-spacing: 0.1px;
  font-weight: 700;
`;
exports.InfoValue = app_1.styled.span `
  color: ${(theme) => theme.colors.gray.semidark};
`;
exports.ChangeButton = (0, app_1.styled)(ui_1.Button) `
  ${(theme) => theme.links.css}
  height: auto;
  padding: 0;
  :hover {
    background: none;
  }
`;
